// extracted by mini-css-extract-plugin
module.exports = {"shareMenu":"ShareMenu_shareMenu__28GGY","shareMenu--top":"ShareMenu_shareMenu--top__2AP9j"};